import EcoNavPage from 'eco-design/sections/eco-nav-page';
import { useLang } from '@/i18n';
import styles from './index.module.scss';
import { useEffect } from 'react';

export default function Comp() {
    const { t } = useLang('powerBank.NavPage');
    const itemsA = [
        {
            title: t('item1'),
            href: '#section-1',
        },
        {
            title: t('item2'),
            href: '#section-2',
        },
        {
            title: t('item3'),
            href: '#section-3',
        },
    ];
    useEffect(() => {
        if (typeof window === 'undefined') return;
        const callback = () => {
            const screen1 = document.getElementById('section-1');
            if (screen1) {
                const screen1Top = screen1.getBoundingClientRect().top;
                if (screen1Top <= 0) {
                    document.getElementById('NavPage')?.classList.add('active');
                } else {
                    document.getElementById('NavPage')?.classList.remove('active');
                }
            }
        };
        window.addEventListener('scroll', callback);
        return () => {
            window.removeEventListener('scroll', callback);
        };
    }, []);
    return (
        <div className={`${styles.comp} GtmModuleData-section`} id='NavPage' data-section-id="Rapid-NavPage">
            <EcoNavPage items={itemsA} />
        </div>
    );
}
